// extracted by mini-css-extract-plugin
export var callCard = "_nd-0";
export var callMessageButton = "_nd-1";
export var helpIcon = "_nd-3";
export var helpIconContainer = "_nd-4";
export var verticalDivider = "_nd-2";